import React from "react";
import { Button, Modal, ModalBody, Spinner } from "reactstrap";
import { Icon } from "../../../components/Component";

const ConfirmationModal = ({
  isOpen,
  toggle,
  onConfirm,
  title = "Confirm Action",
  message = "Are you sure you want to proceed with this action?",
  confirmText = "Confirm",
  cancelText = "Cancel",
  loading = false
}) => {
  return (
    <Modal isOpen={isOpen} toggle={toggle} className="modal-dialog-centered">
      <ModalBody>
        <a
          href="#cancel"
          onClick={(ev) => {
            ev.preventDefault();
            toggle();
          }}
          className="close"
        >
          <Icon name="cross-sm"></Icon>
        </a>
        <div className="p-2">
          <h5 className="title">{title}</h5>
          <div className="mt-3">
            <p>{message}</p>
            <div className="d-flex justify-content-end mt-4">
              <Button color="secondary" className="me-2" onClick={toggle} disabled={loading}>
                {cancelText}
              </Button>
              <Button color="danger" onClick={onConfirm} disabled={loading}>
                {loading ? <Spinner size="sm" /> : confirmText}
              </Button>
            </div>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
};

export default ConfirmationModal;
